import React, { Component } from "react";

import { withRequest } from "../../utils/request";
import {
    getCurrentMonthName,
    formatNumber,
    formatCurrency,
} from "../../utils/helpers";
import Modal from "../general/Modal";
import CreateRegistro from "../Vehiculos/Servicios/Create";
import ServiciosPorVencer from "./ServiciosPorVencer";
import LicenciasPorVencer from "./LicenciasPorVencer";
import SegurosPorVencer from "./SegurosPorVencer";
import ProduccionChart from "./ProduccionChart";
import CategoriasChart from "./CategoriasChart";
import TopChoferes from "./TopChoferes";
import TopRutas from "./TopRutas";
import DashboardTabs, { Tab } from "../general/DashboardTabs";
import CombustibleDisponible from "./CombustibleDisponible";

class HomeDashboard extends Component {
    state = {
        toneladas: 0,
        viajes: 0,
        topChoferes: [],
        topRutas: [],
        produccionCat: [],
        produccionDelMes: [],
        viajesDelMes: [],
        licenciasPorVencer: [],
        segurosPorVencer: [],
        serviciosPorVencer: [],
        gastosPorCategoria: [],
        diasDelMes: [],
        combustibleDisponible: [],
        showRegistro: false,
        vehiculoActivo: {},
        registroActivo: {},
        gastosGenerales: 0,
        gastosCombustible: 0,
        showGastoConfirmation: false,
        activeTab: "servicios",
    };

    componentDidMount() {
        this.getDashboard();
    }
    getDashboard = async (url = "dashboard") => {
        const dashboard = await this.props.request(url);

        if (dashboard.success) {
            this.setState({
                ...dashboard.data,
                anio: parseInt(dashboard.data.anio),
                mes: parseInt(dashboard.data.mes),
                loading: false,
            });
        }
    };

    activateTab = (tab) => {
        this.setState({
            activeTab: tab,
        });
    };

    isActiveClass = (tab) => {
        return tab === this.state.activeTab ? "active" : "";
    };

    nextMonth = async () => {
        const { mes, anio } = this.state;

        if (mes === 12) {
            await this.setState({
                mes: 1,
                anio: anio + 1,
            });
        } else {
            await this.setState({
                mes: mes + 1,
            });
        }

        this.filtroQuery();
    };

    prevMonth = async () => {
        const { mes, anio } = this.state;

        if (mes === 1) {
            await this.setState({
                mes: 12,
                anio: anio - 1,
            });
        } else {
            await this.setState({
                mes: mes - 1,
            });
        }

        this.filtroQuery();
    };

    expandRanking = (rank) => {
        this.setState({
            [rank]: !this.state[rank],
        });
    };

    onFiltroChange = async (e, filtro) => {
        await this.setState({
            [filtro]: e.target ? e.target.value : e,
        });
        this.filtroQuery();
    };

    filtroQuery = () => {
        const query = [`mes=${this.state.mes}`, `anio=${this.state.anio}`];
        this.getDashboard("dashboard?" + query.join("&"));
    };

    toggleRegistroModal = (vehiculo, registro, showGasto = false) => {
        if (vehiculo) {
            this.setState({
                showRegistro: true,
                vehiculoActivo: vehiculo,
                registroActivo: registro,
            });
        } else {
            this.setState({
                showRegistro: false,
                registroActivo: registro,
                showGastoConfirmation: showGasto,
            });
        }
    };
    toggleGastoConfrimation = () => {
        this.setState({
            showGastoConfirmation: !this.state.showGastoConfirmation,
        });
    };
    render() {
        const {
            toneladas,
            topChoferes,
            topRutas,
            produccionCat,
            licenciasPorVencer,
            segurosPorVencer,
            serviciosPorVencer,
            gastosPorCategoria,
            viajes,
            mes,
            anio,
            registroActivo,
            diasDelMes,
            produccionDelMes,
            viajesDelMes,
            combustibleDisponible,
            gastosCombustible,
            gastosGenerales,
        } = this.state;
        let months = [];
        let years = [];
        for (let month = 0; month < 12; month++) {
            months.push({
                numero: month + 1,
                nombre: getCurrentMonthName(month),
            });
        }
        for (let year = 2012; year <= anio; year++) {
            years.push(year);
        }

        const currentMonth =
            mes - 1 + "" + anio ===
            new Date().getMonth() + "" + new Date().getFullYear();

        return (
            <div className='dashboard'>
                <section className='dashboard-header'>
                    <h1>
                        Estadísticas {getCurrentMonthName(mes - 1)} {anio}
                    </h1>
                    <div className='dashboard-dates'>
                        <button
                            className='btn btn-primary'
                            onClick={this.prevMonth}>
                            <i className='zmdi zmdi-chevron-left'></i>
                        </button>
                        <select
                            name='mes'
                            value={mes}
                            onChange={(e) => this.onFiltroChange(e, "mes")}
                            className='form-control'>
                            {months.map((month) => (
                                <option key={month.numero} value={month.numero}>
                                    {month.nombre}
                                </option>
                            ))}
                        </select>
                        <select
                            name='anio'
                            value={anio}
                            onChange={(e) => this.onFiltroChange(e, "anio")}
                            className='form-control'>
                            {years.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </select>
                        <button
                            className='btn btn-primary'
                            onClick={this.nextMonth}
                            disabled={currentMonth}>
                            <i className='zmdi zmdi-chevron-right'></i>
                        </button>
                    </div>
                </section>

                <div className='dashboard-top-section'>
                    <div className='dashboard-column general-data'>
                        <div className='totales-header'></div>
                        <div className='dashboard-block totales'>
                            <div className='totales-value'>
                                {formatNumber(toneladas)}
                            </div>
                            <div className='totales-label'>Toneladas</div>
                        </div>
                        <div className='dashboard-block totales'>
                            <div className='totales-value'>
                                {formatNumber(viajes)}
                            </div>
                            <div className='totales-label'>Viajes</div>
                        </div>
                    </div>
                    <div className='dashboard-column general-data gastos'>
                        <div className='totales-header'></div>
                        <div className='dashboard-block totales'>
                            <div className='totales-value'>
                                {formatCurrency(gastosGenerales)}
                            </div>
                            <div className='totales-label'>
                                Gastos Generales
                            </div>
                        </div>
                        <div className='dashboard-block totales'>
                            <div className='totales-value'>
                                {formatCurrency(gastosCombustible)}
                            </div>
                            <div className='totales-label'>
                                Gastos Combustible
                            </div>
                        </div>
                    </div>
                    <CategoriasChart produccionCat={produccionCat} />
                    <div className='dashboard-column'>
                        <div className='categoria-row'>
                            <div className='categoria-column titulo'>
                                <div className='totales-header'></div>
                                <div className='categoria-titulo'>
                                    <div className='categoria-nombre'>
                                        <span className='categoria-color compactador'></span>
                                        Compactador
                                    </div>
                                    <div className='categoria-cant-vehiculos'>
                                        {produccionCat[0]
                                            ? produccionCat[0].vehiculos
                                            : 0}{" "}
                                        Camiones
                                    </div>
                                </div>
                            </div>
                            <div className='categoria-column'>
                                <div className='totales-header'>Viajes</div>
                                <div className='categoria-valor'>
                                    {produccionCat[0]
                                        ? produccionCat[0].viajes
                                        : 0}
                                </div>
                            </div>
                            <div className='categoria-column'>
                                <div className='totales-header'>Toneladas</div>
                                <div className='categoria-valor'>
                                    {produccionCat[0]
                                        ? formatNumber(
                                              produccionCat[0].toneladas / 1000
                                          )
                                        : 0}
                                </div>
                            </div>
                            <div className='categoria-column'>
                                <div className='totales-header'>TON./Viaje</div>
                                <div className='categoria-valor'>
                                    {produccionCat[0]
                                        ? formatNumber(
                                              produccionCat[0].toneladas /
                                                  1000 /
                                                  produccionCat[0].viajes
                                          )
                                        : 0}
                                </div>
                            </div>
                            <div className='categoria-column'>
                                <div className='totales-header'>Gastos</div>
                                <div className='categoria-valor'>
                                    {formatCurrency(
                                        gastosPorCategoria["Compactador"]
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='categoria-row'>
                            <div className='categoria-column titulo'>
                                <div className='totales-header'></div>
                                <div className='categoria-titulo'>
                                    <div className='categoria-nombre'>
                                        <span className='categoria-color pequeno'></span>
                                        Camión Pequeño
                                    </div>
                                    <div className='categoria-cant-vehiculos'>
                                        {produccionCat[1]
                                            ? produccionCat[1].vehiculos
                                            : 0}{" "}
                                        Camiones
                                    </div>
                                </div>
                            </div>
                            <div className='categoria-column'>
                                <div className='totales-header'>Viajes</div>
                                <div className='categoria-valor'>
                                    {produccionCat[1]
                                        ? produccionCat[1].viajes
                                        : 0}
                                </div>
                            </div>
                            <div className='categoria-column'>
                                <div className='totales-header'>Toneladas</div>
                                <div className='categoria-valor'>
                                    {produccionCat[1]
                                        ? formatNumber(
                                              produccionCat[1].toneladas / 1000
                                          )
                                        : 0}
                                </div>
                            </div>
                            <div className='categoria-column'>
                                <div className='totales-header'>TON./Viaje</div>
                                <div className='categoria-valor'>
                                    {produccionCat[1]
                                        ? formatNumber(
                                              produccionCat[1].toneladas /
                                                  1000 /
                                                  produccionCat[1].viajes
                                          )
                                        : 0}
                                </div>
                            </div>
                            <div className='categoria-column'>
                                <div className='totales-header'>Gastos</div>
                                <div className='categoria-valor'>
                                    {formatCurrency(
                                        gastosPorCategoria["Camión Pequeño"]
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='dashboard-row'>
                    <div className='dashboard-ranking-column'>
                        <TopChoferes choferes={topChoferes} />
                        <TopRutas rutas={topRutas} />
                    </div>
                    <div className='dashboard-column dashboard-right-column'>
                        <ProduccionChart
                            diasDelMes={diasDelMes}
                            produccionDelMes={produccionDelMes}
                            viajesDelMes={viajesDelMes}
                            mes={mes}
                            anio={anio}
                        />
                        {combustibleDisponible.length > 0 && (
                            <CombustibleDisponible
                                contenedores={combustibleDisponible}
                            />
                        )}
                        <div className='dashboard-tabs-widget'>
                            {serviciosPorVencer &&
                                licenciasPorVencer &&
                                segurosPorVencer && (
                                    <DashboardTabs>
                                        <Tab
                                            key='1'
                                            title='Servicios'
                                            counter={serviciosPorVencer.length}>
                                            <ServiciosPorVencer
                                                servicios={serviciosPorVencer}
                                                toggleModal={
                                                    this.toggleRegistroModal
                                                }
                                            />
                                        </Tab>
                                        <Tab
                                            title='Licencias'
                                            key='2'
                                            counter={licenciasPorVencer.length}>
                                            <LicenciasPorVencer
                                                licencias={licenciasPorVencer}
                                            />
                                        </Tab>
                                        <Tab
                                            key='3'
                                            title='Seguros'
                                            counter={segurosPorVencer.length}>
                                            <SegurosPorVencer
                                                seguros={segurosPorVencer}
                                            />
                                        </Tab>
                                    </DashboardTabs>
                                )}
                        </div>
                    </div>
                </div>

                <Modal
                    show={this.state.showRegistro}
                    blank={true}
                    toggle={this.toggleRegistroModal}>
                    <CreateRegistro
                        toggle={this.toggleRegistroModal}
                        vehiculo={this.state.vehiculoActivo}
                        getRegistros={this.getDashboard}
                        registro={this.state.registroActivo}
                    />
                </Modal>
                <Modal
                    title='Registrar gastos...'
                    show={this.state.showGastoConfirmation}
                    toggle={this.toggleGastoConfrimation}
                    acceptText='Ir a gastos'
                    callback={() =>
                        this.props.history.push(
                            `/gastos/crear?registro=${registroActivo.id}&vehiculo=${registroActivo.vehiculoId}&mecanico=${registroActivo.mecanicoId}`
                        )
                    }>
                    ¿Deseas registrar los gastos relacionados a este servicio
                    ahora?
                </Modal>
            </div>
        );
    }
}

export default withRequest(HomeDashboard);
